import { Link } from 'react-router-dom';
import { COMICS } from '@/mocks/comics';

export default function FeaturedComics() {
  const featured = COMICS.filter((c) => c.rating >= 4.8).slice(0, 4);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 max-w-7xl mx-auto">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950">精选推荐</h2>
          <p className="text-sm text-foreground-500 mt-1">编辑团队精心挑选的高分韩漫</p>
        </div>
        <Link
          to="/category/all"
          className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap"
        >
          查看全部 <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop>
        {featured.map((comic) => (
          <Link
            key={comic.id}
            to={`/article/${comic.id}`}
            className="group block"
          >
            <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
              <img
                src={comic.coverImage}
                alt={comic.title}
                title={`${comic.title} - 韩国漫画网 韩漫在线阅读`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute top-2 left-2">
                <span className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${
                  comic.status === '连载中'
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-secondary-500 text-background-50'
                }`}>
                  {comic.status}
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
                <div className="flex items-center gap-1 text-white text-xs">
                  <i className="ri-star-fill text-yellow-400" />
                  <span>{comic.rating}</span>
                </div>
              </div>
            </div>
            <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1">
              {comic.title}
            </h3>
            <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{comic.author} 著</p>
          </Link>
        ))}
      </div>
    </section>
  );
}